import { useQuery, UseQueryResult } from '@tanstack/react-query';
import getUserData_v2 from '@/api/getUserData_v2';
import { UserDTO } from '@/types/other';
import useHasMounted from './useHasMounted';
import { useEffect, useRef, useState } from 'react';

function useUserQuery(initialData: UserDTO | null, isStaticPage: boolean) {
  const hasMounted = useHasMounted();
  const initRefresh = useRef(false);
  const [refreshDone, setRefreshDone] = useState(false);

  const { refetch, ...otherProps } = useQuery<UserDTO | null>({
    queryKey: ['user_v2'],
    queryFn: getUserData_v2,
    enabled: !!initialData || isStaticPage,
    refetchOnWindowFocus: false,
    initialData: initialData,
  });

  useEffect(() => {
    if (otherProps.data) {
      initRefresh.current = true;
      setRefreshDone(true);
    }
  }, [otherProps.data]);

  useEffect(() => {
    async function doRefetch() {
      initRefresh.current = true;
      await refetch();
      setRefreshDone(true);
    }
    if (initialData) {
      doRefetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData, hasMounted]);

  return {
    ...otherProps,
    data: otherProps.data || null,
    refetch,
    refetchDone: refreshDone,
    isLoading: hasMounted ? otherProps.isLoading : true,
  } as UseQueryResult<UserDTO | null> & { refetchDone: boolean };
}

export default useUserQuery;
